import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from '../../../../../../utils/classnames';
import CheckImg from '../../../../../../images/check-grey.svg';
import translation from '../../../../../../languages';
import { PaymentOptionType } from '../../../../../../utils/enhanced-ecommerce';
import { AVAILABLE_PAYMENT_METHODS } from '../../../../payment.constants';
import { PAYMENT_METHOD_KEYS } from '../../../../../../constants/payment-method-keys';
import ToggleButton from '../../../../../../common/toggle-button/toggle-button';
import axios from '../../../../../../utils/axios';
import API_URLS from '../../../../../../constants/api-urls';
import { changeUserDetails } from '../../../../../../reducers/user';
import './paypal-option.scss';
import { changeState } from '../../../../reducers';
import useHasSelectedPaymentMethod from '../../../../hooks/use-has-selected-payment-method';

type PaypalOptionProps = TranslationProps & {
    isActive: boolean;
    onClick: (paymentMethod: PaymentOptionType) => void;
};

const PaypalOption: FC<PaypalOptionProps> = ({ t, ...props }) => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.main.user);
    const { paymentOptionsAvailability } = useSelector((state: RootState) => state.payment);
    const paymentMethod = AVAILABLE_PAYMENT_METHODS[PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT];
    const [isVaultAgreementSelected, setIsVaultAgreementSelected] = useState(Boolean(!user.details.paypalVaultRefused));
    const [isVaultAgreementProcessing, setIsVaultAgreementProcessing] = useState(false);
    const hasSelectedPaymentMethod = useHasSelectedPaymentMethod();
    const optionErrorClass = hasSelectedPaymentMethod ? '' : 'error';

    useEffect(() => {
        dispatch(changeState({ isPayButtonActive: !isVaultAgreementProcessing }));
    }, [isVaultAgreementProcessing]);

    const onVaultAgreementChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const toggleButtonState = event.target.checked;

        setIsVaultAgreementSelected(toggleButtonState);
        setIsVaultAgreementProcessing(true);

        axios.post(API_URLS.PAYMENT_PP_VAULT_AGREEMENT, { isRefused: !toggleButtonState })
            .then(() => {
                dispatch(changeUserDetails({ paypalVaultRefused: !toggleButtonState }));
                dispatch(changeUserDetails({ paypalVaultIdToken: '' }));
            })
            .catch((e) => {
                console.error(e);
                // Revert value
                setIsVaultAgreementSelected(!toggleButtonState);
            }).finally(() => {
            setIsVaultAgreementProcessing(false);
        });

        return false;
    };

    return paymentOptionsAvailability?.get(PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT)
        ? (
            <div
                className={classNames('payment-option paypal-option d-flex', optionErrorClass, {
                    active: props.isActive
                })}
                onClick={props.isActive ? undefined : () => props.onClick(paymentMethod)}>
                <div className='image-holder d-flex justify-content-center align-items-center'>
                    <img src={paymentMethod.img} alt=''/>
                </div>
                <div className='flex-1'>
                    <label htmlFor={paymentMethod.id}>{paymentMethod.title}</label>
                    <div className='description'>
                        <div>{t('payment.paymentMethodSelection.optionDescriptions.paypal')}</div>
                    </div>
                    <img className='check' src={CheckImg} alt=''/>
                </div>
                {Boolean(user?.email) && (
                    <ToggleButton
                        id='vault-agreement'
                        className='vault-agreement'
                        checked={isVaultAgreementSelected}
                        title={t('payment.paymentMethodSelection.paypalVaultAgreementToggle')}
                        onChange={onVaultAgreementChange}
                        isProcessing={isVaultAgreementProcessing}
                    />
                )}
            </div>
        ) : <></>;
};

const translate = translation('payment');

export default translate(PaypalOption);
